import { SetStateAction, useContext, useEffect } from "react"

import AlgoliaContext from "../context/AlgoliaContext"

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import {MdOutlineExpandMore} from 'react-icons/md';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox'; 

interface CategoryFiltersProps {
    categoryFilters: string[] | null,
    setCategoryFilters: React.Dispatch<SetStateAction<string[] | null>> 
} 

const CategoryFilters:React.FC<CategoryFiltersProps> = ({categoryFilters, setCategoryFilters}) => {

    const {
        categories,
        getCurrentTidParams,
        windowHrefTids
    } = useContext(AlgoliaContext);

    const urlTid:string[] = getCurrentTidParams();
    
    const handleAdd = (filter:string) => {

        if (categoryFilters) {

            let newCatF:string[] = [...categoryFilters, filter];
            setCategoryFilters(newCatF);
            
        };
    };
    
    const handleRemove = (filter:string) => {

        if (categoryFilters) {

            let newCatF:string[] = categoryFilters.filter((cat) => {
                return cat !== filter;
            })
            setCategoryFilters(newCatF);

      };   

    };

    // useEffect(() => {
    //     if (urlTid && urlTid.length > 0) {
    //         urlTid.forEach((filter) => {
    //             handleAdd(filter);
    //         });
    //     }
    // }, []);

    if (categoryFilters) {

        return (
            <div className="flex flex-col items-center justify-center w-full">
                {
                    categories.map((sub, i) => {

                        let expanded = false;
                        
                        sub.sub_categories.forEach((subsub) => {
                            if (urlTid.includes(subsub.category_id)) {
                                expanded = true;
                            };
                        });

                        return (


                        <Accordion className="w-full"
                        key={i}
                        defaultExpanded={expanded} 
                        >
                            <AccordionSummary
                            expandIcon={<MdOutlineExpandMore />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            >
                                <p>{sub.category_name}</p>

                            </AccordionSummary>
                            <AccordionDetails>

                                {sub.sub_categories.map((subsub) => {
                                    return (
                                    <FormGroup>
                                        <FormControlLabel control={<Checkbox 

                                        defaultChecked={urlTid.includes(subsub.category_id) ? true : false}
                                        
                                        onChange={(e) => {
                                            e.target.checked ? 
                                            handleAdd(subsub.category_id)
                                            : handleRemove(subsub.category_id)
                                        }}
                                        
                                        />} label={subsub.category_name} />
                                    </FormGroup>
                                    )
                                })}

                            </AccordionDetails>
                        </Accordion>                  
                        
                        )
                    })
                }
            </div>
        )

        
    } else return null

}

export default CategoryFilters